import PaperIcon from '@/common/assets/icons/paperIcon.svg?react';
import SmallCarIcon from '@/common/assets/icons/smallCarIcon.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import BodyCustomerAttachedVehicleImagesTab from '@/modules/adjusterReportModules/Insurer-information/components/images/customerImages/attachmentImages/BodyCustomerAttachedVehicleImagesTab';
import BodyCustomerDocumentImagesTab from '@/modules/adjusterReportModules/Insurer-information/components/images/customerImages/attachmentImages/BodyCustomerDocumentImagesTab';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout
      title="بیمه گذار / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <BodyCustomerAttachedImages />
    </MainLayout>
  );
};

const BodyCustomerAttachedImages = () => {
  const [activeTab, setActiveTab] = useState(1);

  const firstTabElement = <BodyCustomerAttachedVehicleImagesTab />;
  const tabs = [
    {
      title: 'تصاویر وسیله‌نقلیه',
      activeTabIndex: 1,
      icon: <SmallCarIcon stroke={'currentColor'} />,
    },
    {
      title: 'تصاویر مدارک',
      activeTabIndex: 2,
      icon: <PaperIcon stroke={'currentColor'} />,
    },
  ];
  return (
    <Box mt="5.5rem">
      <TitleDescription>تصاویر الحاقی</TitleDescription>
      <Box mt="24px">
        <SwitchTab
          activeTab={1}
          tabs={tabs}
          getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
        />
        {activeTab === 1 ? firstTabElement : null}
        {activeTab === 2 ? <BodyCustomerDocumentImagesTab /> : null}
      </Box>
    </Box>
  );
};
